import { useGlobalController, useModel, useRoute } from "@bcm-dev/bcms-vite";
import { Account, CheckingAccount, CODAccount, LoanAccount, SavingsAccount, Transaction } from "model";
import React from "react";
import { SVGAsset } from 'res';
import CustomSelect, { CustomSelectItem } from "../CustomSelect";
import "./styles.css";
import "./mobile.css";

/**
 * @name AccountSelect
 * @function
 * @param {STRING|NUMBER|NULL} value - what value to set in the input as a default
 * @param {Array} accounts - [accounts] what accounts to show in the drop down
 * @param {ReactComponentElement} SelectedItem - ((value)->React.Component) custom element for a selected item
 * @extends React.Component
 * @exported true
 * @description The main component for a custom select
 * @example 
 *     <CustomAccountSelect accounts={accounts} value={3}/>
 *  );
 * }
 */
export default function AccountSelect(props) {
    let controller = useGlobalController();
    Account.globalControllerFor([Account, CheckingAccount, SavingsAccount, CODAccount, LoanAccount, Transaction], controller);
    let accounts = Account.initAll();
    const navigate = useRoute();  
    let onChange = (value) => {        
            navigate(`/accountdetails/${value.id}`);        
    }

    //builds a list of account items for the drop down
    let accountItems = accounts.map((account) => {
        return <AccountSelectItem value={account} key={account.id} />
    })    
    return (
        //returns a custom select using AccountSelectItem for the items and the AccountSelectedAccount for the selected item view 
        <CustomSelect active={ props.active ?? false } className="custom-account-select" value={props.account||accounts[0]} onChange={onChange} SelectedItem={AccountSelectedItem} >
            {accountItems}
        </CustomSelect>
    );
}
/**
 * @name AccountSelectItem
 * @function 
 * @param {Array} account - account instance
 * @extends React.Component
 * @exported true
 * @description What gets shown in the account select drop down
 */
export function AccountSelectItem(props) {
    let account = props.value;
    
    let balanceLabel = account.balanceLabel;
    let balance = account.balanceLabel === "Available" ? account.availableBalance.format() : account.currentBalance.format();

    // Show "Available Credit" for loc accounts.
    if(Account.isLOC(account)) {
        balanceLabel = account.secondaryBalanceLabel;
        balance =  account.availableCredit.format();
    }
    
    return (
        <CustomSelectItem value={account}>
            <div className="account-name" data-point={ `Account_Dropdown_Select_Name_${ account.id }` }>{`${account.nickname} - ${account.number}`}</div>
            <div className="account-details" data-point={ `Account_Dropdown_Select_Avail_Balance_${ account.id }` }>{`${ balanceLabel } ${ balance }`}</div>
        </CustomSelectItem>

    );
}
/**
 * @name AccountSelectedItem
 * @function 
 * @param {Array} account - account instance
 * @extends React.Component
 * @exported true
 * @description What gets shown for a selected account
 */
export function AccountSelectedItem(props) {
    const { branding } = useModel();
    const { options } = branding;
    const arrowPosition = options.ddarrow_position_abi22 === "undefined" ? "Right" : options.ddarrow_position_abi22;
    const arrowsPositionIsRight = arrowPosition === "Right";
    const arrowClass = arrowPosition === "Left" ? "left-arrow" : "right-arrow";
    let account = props.value;

    return (
        <>
            <div className={ `flex-container flex-horizontal align-center content-header ${ arrowClass }` }>
                <div onClick={props.controller.toggle} className="account-select-placeholder flex-container flex-horizontal all-center clickable" data-point="Account_Details_Dropdown">
                    <SVGAsset id="DownChevronIcon" />
                </div>
                <span className={ `account-name-label ${ arrowsPositionIsRight ? "truncate-text" : "" }` }>{`${account.nickname || ""}`} </span>
            </div>
        </>
    );
}